import React from 'react';
import PropTypes from 'prop-types';
import { Link, useParams } from 'react-router-dom';

const SectionTopMenu = ({ clientName, promotionName }) => {
  const { clientId, promotionId } = useParams();
  return (
    <div className="section-top-menu-header">
      <div className="divider" />
      <Link to={`/client/${clientId}`}>
        <div className="client-name">{clientName}</div>
      </Link>
      {promotionName != null
      && (
        <Link to={`/client/${clientId}/${promotionId}`}>
          <div className="promotion-name">{promotionName}</div>
        </Link>
      )}
    </div>
  );
};

SectionTopMenu.propTypes = {
  clientName: PropTypes.string.isRequired,
  promotionName: PropTypes.string,
};
SectionTopMenu.defaultProps = {
  promotionName: null,
};
export default SectionTopMenu;
